<template>
  <v-card
    class="pa-4"
    flat
    :style="{
      background: bstyle.backGround,
      color: bstyle.text,
    }"
  >
    <v-card-title class="section-title pa-2">
      {{ title }}
    </v-card-title>
    <v-card-subtitle class="ma-0 pa-2">
      {{ description }}
    </v-card-subtitle>

    <v-row v-if="type === 'default'" no-gutters>
      <v-col v-for="(item, i) in value" :key="i" cols="12">
        <b-blog-card :data="item" :bstyle="bstyle" />
      </v-col>
    </v-row>

    <swiper-wrapper
      v-else
      :loop="true"
      :show-arrows="true"
      wrapper-class="b-blog"
    >
      <div v-for="(item, i) in value" :key="i" class="swiper-slide">
        <b-blog-card :data="item" :bstyle="bstyle" />
      </div>
    </swiper-wrapper>
  </v-card>
</template>

<script>
import BBlogCard from "../cm/bBlogCard";
import SwiperWrapper from "../cm/swiperWrapper";

export default {
  name: "bBlogView",

  components: { SwiperWrapper, BBlogCard },

  props: {
    type: {
      type: String,
      default: "slider",
    },
    title: String,
    description: String,
    value: {
      default: Array,
    },
    bstyle: Object,
  },
};
</script>

<style scoped>
.section-title {
  position: relative;
}

.section-title::before {
  content: "";
  width: 150px;
  height: 1px;
  background: var(--v-primary-base);
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
